import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../actions";
import strings from "../../helpers/Localization";
import { toast } from "react-toastify";

//CUSTOM ELEMENTS
import { GetContentTranslations } from "../../helpers/Language";

import AddTags from "../../aGlobalDesign/Tags/AddTags";
import Area from "../../aGlobalDesign/Area/Area";
import ButtonSkaRound from "../../aGlobalDesign/Buttons/ButtonSkaRound";
import Modal from "../..//aGlobalDesign/Modal/Modal";
import PaginationList from "../../aGlobalDesign/Pagination/PaginationList";
import Thumbnail from "../../aGlobalDesign/Avatar/Thumbnail";
import TagChip from "../../aGlobalDesign/Tags/TagChip";
import CardResource from "../../aGlobalDesign/Cards/CardResource";

class ContentsList extends React.Component {

    constructor() {
        super();
        this.state = {
            searchField: "",
            isSelectOpen: false,
            renameDialog: null,
            renameDialogText: "",
            maxStorageSize: 10,
            forcePaginationUpdate: 0,
            temporaryElement: null,
            tempEditContent: null,
            showEditTagDialog: false,
            saving: false,
            reload: new URLSearchParams(new URL(window.location.href).search).get("reload")
        };
    }

    componentDidMount() {
        this.props.changeAppBarTitle(strings.ContentLibrary);
        this.props.ChangeCurrentMenuName("ContentLibrary");
        this.props.GetAllTags();

        /*const maxStorageSize = this.props.currentuser.currentorganization.organizationParameters.find(op => op.key === "Public-MaxStorageSpace");
        if (maxStorageSize === undefined) {this.setState({ maxStorageSize: 10 });}
        else {this.setState({ maxStorageSize: Number(maxStorageSize.value) });}*/
    }
    forcePaginationUpdate() {
        const temp = this.state.forcePaginationUpdate + 1;
        this.setState({
            tempEditContent: null,
            forcePaginationUpdate: temp
        });
    }
    componentDidUpdate(prevProps) {
        const reload = new URLSearchParams(new URL(window.location.href).search).get("reload");
        if (reload && this.state.reload !== reload) {
            this.setState({ reload: reload });
            this.forcePaginationUpdate();
        }
    }

    //#region functions
    OndeleteContent(Id, onSuccess) {
        this.props.OpenDialog({
            title: strings.confirmDeleteItemContent,
            description: strings.confirmDeleteItemDesc,
            secondaryLabel: strings.cancel,
            primaryLabel: strings.confirmDelete,
            onPrimaryAction: () => {
                this.props.DeleteContent(Id, () => {
                    this.forcePaginationUpdate();
                });
            }
        });
    }
    OnLoadClick(element) {
        const temp = this.CreateTemp(element);
        this.setState({
            tempEditContent: element,
            temporaryElement: temp
        });
    }
    CreateTemp(element) {
        const temp = {
            id: element.id,
            name: element.name,
            data: element.data,
            tags: element.tags
        };
        return temp;
    }
    SaveTemp(temp, element) {
        element.name = temp.name;
        element.data = temp.data;
        return element;
    }
    SaveContent() {
        const temp = this.SaveTemp(this.state.temporaryElement, this.state.tempEditContent);
        if (temp.name === "") {
            this.props.OpenDialog({
                description: strings.mustHaveName,
                primaryLabel: "OK",
                clickOutsideToClose: true
            });
            return;
        }
        const obj = {
            id: temp.id,
            name: temp.name,
            contentTypeId: temp.contentTypeId,
            contentGroupId: temp.contentGroupId,
            timestamp: temp.timestamp,
            data: temp.data
        };

        //we edit the tags
        const newTags = this.state.tempEditContent.tags ? this.state.tempEditContent.tags : [];
        const curTags = this.state.temporaryElement.tags ? this.state.temporaryElement.tags : [];


        const tagsToRemove = [];
        const tagsToAdd = [];
        const tagsToCreate = [];
        curTags.forEach(tag => {
            if (!newTags.some(t => t.value === tag.value)) {
                tagsToRemove.push(tag);
            }
        });
        newTags.forEach(tag => {
            if (!curTags.some(t => t.value === tag.value)) {
                if (!this.props.dictionaries.tags.some(t => t.value === tag.value)) {
                    tagsToCreate.push(tag);
                }
                else {
                    tagsToAdd.push(tag);
                }
            }
        });

        if (temp.id > 0) {
            this.props.CreateMultipleTag(tagsToCreate.map(t => {return t.value;}), temp.id, "content", () => {
                this.props.AddMultipleTag(tagsToAdd, temp.id, "content", () => {
                    this.props.RemoveMultipleTags(tagsToRemove, temp.id, "content", () => {
                        this.props.GetAllTags();
                        const formData = new FormData();
                        formData.append("contentObjAsString", JSON.stringify(obj));
                        this.props.EditContent(
                            formData,
                            (updatedContentTimestamp) => {
                                toast.success(strings.successfullSave);
                                this.forcePaginationUpdate();
                                this.setState({
                                    tempEditContent: null
                                });
                            },
                            () => {}
                        );
                    });
                });
            });
        }
        else {
            const formData = new FormData();
            formData.append("contentObjAsString", JSON.stringify(obj));
            this.props.CreateContent(
                formData,
                (updatedContentTimestamp) => {
                    toast.success(strings.successfullSave);
                    this.forcePaginationUpdate();
                    this.setState({
                        tempEditContent: null
                    });
                },
                () => {}
            );
        }
    }
    getContentTypes() {
        return [
            { id: 20, name: strings.imageTitle },
            { id: 30, name: strings.videoTitle },
            { id: 40, name: strings.pdfTitle },
            { id: 10, name: strings.feedUrl }
        ];
    }
    //#endregion

    render() {
        const accessrights = this.props.currentuser && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : {};
        const isSystemAdministrator = this.props.currentuser && this.props.currentuser.user && this.props.currentuser.user.isSystemAdministrator;

        return <>
            <Area
                helmet={strings.helmetContentLibrary}
                title={strings.ContentLibrary}
                sideButtons={[
                    {
                        type: "primary-icon",
                        nameIcon: "url",
                        text: strings.AddWebLink,
                        onClick: () => {
                            const tempContent = {
                                id: 0,
                                name: "",
                                contentTypeId: 10,
                                data: JSON.stringify({ weburl: "" }),
                                tags: []
                            };
                            this.OnLoadClick(tempContent);
                        }
                    },
                    {
                        type: "primary-icon",
                        nameIcon: "upload",
                        text: strings.ImportFilesTitle,
                        onClick: () => this.props.history.push("/Resources/ImportFiles")
                    }
                ]}
            >
                <PaginationList
                    forcePaginationUpdate={this.state.forcePaginationUpdate}

                    onGetElements={
                        (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary) =>
                            this.props.GetContentsList(pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary)
                    }
                    onSavePagination={this.props.SaveContentPagination}
                    myElements={this.props.contents.contents}

                    tags={this.props.dictionaries.tags}

                    filterOptions={[
                        {
                            filterName: "name",
                            filterType: "text",
                            title: strings.name
                        },
                        {
                            filterName: "contenttypeid",
                            filterType: "select",
                            title: strings.SortContentType,
                            list: this.getContentTypes()
                        }
                    ]}
                    sortOptions={[
                        { sortName: "name", sortData: "null" },
                        { sortName: "langs", sortData: "null" },
                        { sortName: "contentGroupName", sortData: "null" },
                        { sortName: "lastdatecreated", sortData: "desc" },
                        { sortName: "lastModifiedBy", sortData: "null" },
                        { sortName: "contentTypeName", sortData: "null" }
                    ]}

                    cardElement={(element) => {
                        const data = element && element.data ? JSON.parse(element.data) : {};
                        return <CardResource
                            type={element ? element.content ? element.content.contentType : element.contentType : null}
                            thumbnailURL={data.ThumbnailUri}
                            onClick={() => window.open(data.Uri, "_blank", "rel=noopener noreferrer")}
                            name={element.name}
                        />;
                    }}
                    tableElement={(element) => {
                        const data = element && element.data ? JSON.parse(element.data) : {};
                        return [
                            {
                                colTitle: strings.SortContentType,
                                sortIndex: 5,
                                colContent: element ? element.content ? element.content.contentType.name : element.contentType.name : null,
                                fixedWidth: "100px"
                            },
                            {
                                colTitle: strings.SortPreview,
                                cellRenderer: ({ tableManager, stringvalue, field, data, column, colIndex, rowIndex }) => {
                                    const value = data[column.field];
                                    if (value && value.ThumbnailUri) {
                                        return <div className="thumbnailInteractive">
                                            <Thumbnail
                                                href={value.ThumbnailUri}
                                                onClick={() => window.open(value.Uri, "_blank", "rel=noopener noreferrer")}
                                            />
                                        </div>;
                                    }
                                    return "";
                                },
                                fixedWidth: "100px",
                                colContent: element && element.data && data.ThumbnailUri ? {
                                    ThumbnailUri: data.ThumbnailUri,
                                    Uri: data.Uri
                                } : null,
                                lockWidth: true,
                                justify: "center"
                            },
                            {
                                colTitle: strings.title,
                                sortIndex: 0,
                                colContent: element ? element.name : null,
                                fixedWidth: "400px"
                            },
                            {
                                colTitle: strings.tags,
                                fixedWidth: "200px",
                                cellRenderer: ({ data, column }) => {
                                    const value = data[column.field];
                                    if (value && value.tags) {
                                        return (
                                            <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                                                {
                                                    value.tags.length <= 3
                                                        ? value.tags.map((tag, index) => {
                                                            return (
                                                                <TagChip
                                                                    key={index}
                                                                    tagName={tag.value}
                                                                    onDelete={() => {
                                                                        this.props.RemoveMultipleTags([tag], value.id, "content", () => {
                                                                            this.props.GetAllTags();
                                                                            this.forcePaginationUpdate();
                                                                        });
                                                                    }}
                                                                />
                                                            );
                                                        })
                                                        : value.tags.slice(0, 3).map((tag, index) => {
                                                            return (
                                                                <TagChip
                                                                    key={index}
                                                                    tagName={tag.value}
                                                                    onDelete={() => {
                                                                        this.props.RemoveMultipleTags([tag], value.id, "content", () => {
                                                                            this.props.GetAllTags();
                                                                            this.forcePaginationUpdate();
                                                                        });
                                                                    }}
                                                                />
                                                            );
                                                        })}
                                                {
                                                    value.tags.length <= 3 ? null : " +" + (value.tags.length - 3)
                                                }
                                            </div>
                                        );
                                    }
                                    return "";
                                },
                                colContent: element && element.tags ? { id: element.id, tags: element.tags } : null
                            },
                            {
                                colTitle: strings.SortDateCreated,
                                sortIndex: 3,
                                fixedWidth: "180px",
                                lockWidth: true,
                                colContent: element?.dateCreated ? element.dateCreated : null,
                                // formatted displaying
                                cellRenderer: ({ data, column }) => {
                                    const value = data[column.field];
                                    return value ? this.props.parseDate(value) : "";
                                }
                            },
                            {
                                colTitle: strings.SortCreatedBy,
                                sortIndex: 4,
                                fixedWidth: "320px",
                                colContent: element && element.creator ? element.creator.email : null
                            },
                            {
                                colTitle: strings.actions,
                                colType: "actions",
                                actions: [1, 2],
                                colContent: [
                                    <ButtonSkaRound
                                        key={"edit"}
                                        isDisabled={!accessrights || accessrights.hasPermission(40, "modify") <= 10}
                                        type="primary"
                                        nameIcon="edit"
                                        onClick={() => this.OnLoadClick(element)}
                                    />,
                                    <ButtonSkaRound
                                        key={"trash"}
                                        isDisabled={!accessrights || accessrights.hasPermission(40, "delete") <= 10}
                                        type="primary"
                                        nameIcon="trash"
                                        onClick={() => this.OndeleteContent(element.id)}
                                    />
                                ]
                            }
                        ];
                    }}
                />
            </Area>
            <Modal open={this.state.tempEditContent !== null}
                hide={this.state.showEditTagDialog}
                onClose={() => !this.state.saving ? this.setState({
                    tempEditContent: null
                }) : null}
                validationIcon="save"
                validationTitle={this.state.tempEditContent && this.state.tempEditContent.id > 0 ? strings.register : strings.createContent}
                icon={this.state.tempEditContent && this.state.tempEditContent.id > 0 ? "edit" : "add"}
                onValidate={!this.state.saving ? () => { this.SaveContent(); } : null}
                title={strings.editContent}
                fields={this.state.tempEditContent ?
                    [{
                        type: "textfield",
                        title: strings.title,
                        placeholder: strings.name,
                        value: this.state.temporaryElement.name,
                        onChange: (e) => {
                            const tempEdit = this.state.temporaryElement;
                            tempEdit.name = e.target.value;
                            this.setState({
                                temporaryElement: tempEdit
                            });
                        }
                    },
                    this.state.tempEditContent.contentTypeId === 10 ? {
                        type: "prefixedTextfield",
                        title: strings.feedUrl,
                        prefix: "https://",
                        value: JSON.parse(this.state.temporaryElement.data).weburl,
                        onChange: (e) => {
                            this.setState({
                                temporaryElement: { ...this.state.temporaryElement, data: JSON.stringify({ weburl: e.target.value }) }
                            });
                        }
                    } : null,
                    this.state.tempEditContent.id > 0 ? {
                        type: "custom",
                        title: strings.tags,
                        child: <AddTags
                            allTags={this.props.dictionaries.tags}
                            elementTags={this.state.tempEditContent.tags}
                            onOpenModal={() => {this.setState({ showEditTagDialog: true });}}
                            onCloseModal={() => {this.setState({ showEditTagDialog: false });}}
                            onChangeTags={(addList, createList, tagsToRemove) => {
                                const temp = this.state.tempEditContent;
                                const newList = [...addList, ...createList];
                                temp.tags.forEach(tag => {
                                    if (!tagsToRemove.some(t => t.value === tag.value)) {
                                        newList.push(tag);
                                    }
                                });
                                temp.tags = newList;
                                this.setState({ tempEditContent: temp });
                            }}
                        />
                    } : null] : []}
            />
        </>;

    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default connect(
    (state) => state,
    mapDispatchToProps
)(ContentsList);
